export const apiRouteName = 'api';
export const contentRouteName = 'content';
export const queryRouteName = 'query';

export const routeRoot = 'app/auto/';

export const routeApi = `${routeRoot}${apiRouteName}`;
export const routeQuery = `${routeRoot}${queryRouteName}`;
export const routeContent = `${routeRoot}${contentRouteName}`;
